import { AnyAction } from 'redux';
// import * as actionTypes from '../actions/user';
import Roles from '../../common/constants/roles';
import qs from 'qs';

const qsData = qs.parse(window.location.search, { ignoreQueryPrefix: true });

const getRole = () => {
  const isPresenter = !!window.authToken;
  const isParticipant = !!qsData.socket_room && !isPresenter;

  if (isPresenter) {
    return Roles.ROLE_PRESENTER;
  } else if (isParticipant) {
    return Roles.ROLE_PARTICIPANT;
  } else {
    return Roles.ROLE_USER;
  }
};

const initialState = {
  current: {
    loaded: false,
    error: undefined,
    data: {
      role: getRole(),
    },
  },
};

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    default:
      return state;
  }
};
